import Config from "./Config";

export const endpoint = `${Config.apis.backend || "http://localhost:5001"}/api`;
